import { saveOptLogSnap } from '../serve/material';
// 导出一个函数，用于保存操作日志快照
export async function saveOptLogSnapFunc(params) {
  try {
    const logResult = await saveOptLogSnap(params);
    console.log(logResult, 'cgl--saveOptLogSnap');
    return logResult;
  } catch(error) {
    console.error(error, 'saveOptLogSnap error');
  }
}
